import { Schema } from 'effect';
import { SiteId } from './common.js';
/** DTO schemas for the /coupon group. See http/payment.ts for conventions. */
export const SiteParams = Schema.Struct({ site: SiteId });
export const CouponParams = Schema.Struct({
    site: SiteId,
    couponId: Schema.String
});
export const CreateResponse = Schema.Struct({ couponId: Schema.String });
//# sourceMappingURL=coupon.js.map